<template>
	<div>
		<div v-if="pageloader_value">
			<div class="loader" v-if="type == 'complete'">
			</div>
			<div class="loader homechartloader py-5" v-else></div>
		</div>

		
	</div>
</template>
<script>
	export default {
		name: 'LoaderComponent',
		data() {
			return { }
		},
		props:['pageloader_value','type']
	}
</script>


// WEBPACK FOOTER //
// src/components/fxView/shared/complete_loading.vue